import { useLang } from "@/i18n";

const LANGS = [
  { code: "pl", label: "PL" },
  { code: "en", label: "EN" },
  { code: "ru", label: "RU" },
];

export default function LanguageSwitcher({ variant = "dark" }) {
  const { lang, setLang } = useLang();
  const base = variant === "dark"
    ? "text-cream/70 hover:text-gold"
    : "text-navy-deep/60 hover:text-gold";
  return (
    <div data-testid="lang-switcher" className="flex items-center gap-1 text-xs font-semibold tracking-wider">
      {LANGS.map((l, i) => (
        <span key={l.code} className="flex items-center">
          {i > 0 && <span className={`mx-1 ${variant === "dark" ? "text-cream/30" : "text-navy-deep/30"}`}>·</span>}
          <button
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`${base} transition ${lang === l.code ? (variant === "dark" ? "text-gold" : "text-navy-deep font-bold") : ""}`}
          >
            {l.label}
          </button>
        </span>
      ))}
    </div>
  );
}
